import React, { Component } from "react";
import { View, Text } from "react-native";
import CardForm from "./CardForm.js";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {
  useStripe,
  useElements,
  CardElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { MyCart, Constant } from "./Data.js";

// import useResponsiveFontSize from "../../useResponsiveFontSize";
import axios from "axios";

const firebaseConfig = {
  apiKey: "AIzaSyDaeu9mbyaZEUAiMUWIEiSu5cStW--Ga8g",
  authDomain: "flyby-nyc20.firebaseapp.com",
  databaseURL: "https://flyby-nyc20.firebaseio.com",
  projectId: "flyby-nyc20",
  storageBucket: "flyby-nyc20.appspot.com",
  messagingSenderId: "479082390845",
  appId: "1:479082390845:web:6a04b019caa0b06bd11154",
};

// const stripePromise = loadStripe(
//   "pk_test_51H7XFvJB6x3gXxqhOlX80i2u7S48z1TO7eRBvHaqNl5bDDNxSNPhhm3IrPmHkBBOn4qtlusSnf1IsuEHImwFgWR500mZ8uQC34",
//   { stripeAccount: "acct_1GS77IGHj8WvG6vy" }
// );

export default class CheckoutScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Elements
        stripe={loadStripe(Constant.stripePublicKey, {
          stripeAccount: this.props.route.params.stripeID,
        })}
      >
        <CardForm
          stripeID={this.props.route.params.stripeID}
          name={this.props.route.params.name}
          restaurantID={this.props.route.params.restaurantID}
          tableID={this.props.route.params.tableID}
          totalAmount={this.props.route.params.totalAmount}
          subTotalAmount={this.props.route.params.subTotalAmount}
          tipAmount={this.props.route.params.tipAmount}
          myCart={this.props.route.params.myCart}
        />
      </Elements>
    );
  }
}

// <CardForm
//   stripeID={this.props.route.params.stripeID}
//   name={this.props.route.params.name}
//   restaurantID={this.props.route.params.restaurantID}
//   tableID={this.props.route.params.tableID}
//   totalAmount={this.props.route.params.totalAmount}
//   subTotalAmount={this.props.route.params.subTotalAmount}
//   tipAmount={this.props.route.params.tipAmount}
//   myCart={this.props.route.params.myCart}
// />
// <CardForm
//   stripeID={"acct_1GS77IGHj8WvG6vy"}
//   name={"Solo's Bristro X"}
//   restaurantID={"R0gcrLEUXbMcC4wCtei7zxkhnTl1"}
//   tableID={"9"}
//   totalAmount={"24.25"}
//   subTotalAmount={"21.5"}
//   tipAmount={"1.4"}
//   myCart={{}}
// />
